import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.SubmitFeedback = {
  displayName: 'SubmitFeedback',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    onStepProgression()
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    componentDidMount: function() {
      this.createJobClosure()
    },

    createJobClosure: function() {
      let surveyData = Job.Data.closureSurvey

      $.ajax({
        url: `/jobs/job/${surveyData.job.id}/closure`,
        type: 'PUT',
        dataType: 'json',
        data: {
          survey: {
            closure: {
              outcome: surveyData.outcome,
              provider_account_id: surveyData.providerAccountId,
              value: surveyData.value
            },
            closure_history: {
              trigger: 'job_modal',
              medium: 'web'
            },
            feedback: {
              rating: surveyData.rating,
              comments: surveyData.comments
            },
            feedback_reasons: surveyData.selectedReasons,
            from_fast_feedback: false
          }
        }
      }).done((data) => {


        if (surveyData.rating) {
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.PostJobAgain)
        } else {
          this.redirectToJobPage()
        }
      }).fail((jqXHR, textStatus) => {
        document.location.href = '/500'
      })
    },

    redirectToJobPage: function(){
      let jobID = Job.Data.id
      let url = ''

      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }

      document.location.href = url
    },

    render: function() {
      return (
        <div className="modal-body job-closure-form-body">
          <h3>Saving feedback details...
            <div className="spinner-icon text-center ml15"/>
          </h3>
        </div>
      )
    }
  })
}
